// A frozen piece cannot be jumped over (§31 C2, the Stasis Field).
//
// A leap traverses nothing, so "over" needs a reading: **a leap passes over
// every square inside the rectangle its two ends span** — both L-routes of a
// knight, a Pegasus' (3,2), a Gryphon's — and a frozen piece standing on one
// stops the leap. One body, asked by `moveGen` and by `attacks.ts`, or a leap
// the sweep sees and movegen refuses (or the reverse) is a check out of
// nowhere. Callers gate on `pos.armour.size`, so perft cannot see this.

import { fileOf, rankOf } from "../board";
import { armourLeft, pieceAt, type Position } from "../position";

/** Does the leap `from` -> `to` pass over a frozen piece? */
export function leapCrossesStasis(pos: Position, from: number, to: number): boolean {
  const f0 = fileOf(from);
  const r0 = rankOf(from);
  const f1 = fileOf(to);
  const r1 = rankOf(to);
  const fl = Math.min(f0, f1);
  const fh = Math.max(f0, f1);
  const rl = Math.min(r0, r1);
  const rh = Math.max(r0, r1);
  for (const sq of pos.armour.keys()) {
    if (sq === from || sq === to) continue;
    const f = fileOf(sq);
    const r = rankOf(sq);
    if (f < fl || f > fh || r < rl || r > rh) continue;
    if (armourLeft(pos, sq) > 0 && pieceAt(pos, sq) !== 0) return true;
  }
  return false;
}
